import {
  ConnectivityRanking,
  DataTrendingRequestBody,
  GenericDataResponse,
  PropertySincePayload,
  PropertySinceResponse,
  RawTrendingData,
} from './analytics.model';

export class MockedDeviceAvailableProperties {
  mock(body: PropertySincePayload): GenericDataResponse<PropertySinceResponse> {
    return {
      data: {
        gateway_id: body.gateway_id,
        device_id: body.device_id ?? '0',
        properties: [
          {
            property: 'electricity.consumption.device.compressor',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.total',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.heating.percentage',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.heating',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.dhw.percentage',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.dhw',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.domesticHotWater.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.power.consumption.comparison.previousweek.percentage',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.device.compressor.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.cooling.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.cooling',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.centralHeating.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.domesticHotWater',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.usage.centralHeating',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.total',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.device.electricHeater.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.cooling.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.centralHeating.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.centralHeating',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.total',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.domesticHotWater.percent',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.spf.dhw',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.spf.heating',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.spf.total',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'heating.seer.cooling',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.cooling',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'electricity.consumption.device.electricHeater',
            start_datetime: '2023-04-14T11:57:54+02:00',
          },
          {
            property: 'thermal.output.usage.domesticHotWater',
            start_datetime: '2023-04-14T13:17:29+02:00',
          },
          {
            property: 'heating.dhw.temperature.main.min',
            start_datetime: '2023-04-14T13:47:54+02:00',
          },
          {
            property: 'heating.dhw.temperature.main.max',
            start_datetime: '2023-04-14T13:47:54+02:00',
          },
          {
            property: 'heating.dhw.temperature.main.avg',
            start_datetime: '2023-04-14T13:47:54+02:00',
          },
          {
            property: 'heating.sensors.temperature.outside.avg',
            start_datetime: '2023-04-14T14:36:58+02:00',
          },
          {
            property: 'heating.sensors.temperature.outside.max',
            start_datetime: '2023-04-14T14:36:58+02:00',
          },
          {
            property: 'heating.sensors.temperature.outside.min',
            start_datetime: '2023-04-14T14:36:58+02:00',
          },
          {
            property: 'temperature.forecast.outside.7d.avg',
            start_datetime: '2023-05-11T00:00:00+02:00',
          },
          {
            property: 'temperature.forecast.outside.7d.max',
            start_datetime: '2023-05-11T00:00:00+02:00',
          },
          {
            property: 'temperature.forecast.outside.7d.min',
            start_datetime: '2023-05-11T00:00:00+02:00',
          },
        ],
      },
    };
  }
}

export class MockedTrendingData {
  mock(body: DataTrendingRequestBody): { data: RawTrendingData[] } {
    const point_start = new Date(body.start_datetime).getTime();
    const point_end = new Date(body.end_datetime).getTime();
    const timeDiff = point_end - point_start;

    return {
      data: [
        {
          gateway_id: body.gateway_id,
          device_id: body.device_id ?? ['0'],
          point_interval: 3600000,
          point_start,
          point_end,
          datalength: 192,
          resolution: '1h',
          enum_properties: {
            'heating.circuits.0.circulation.pump/status': {
              '0': 'off',
              '1': 'on',
            },
            'heating.circuits.1.circulation.pump/status': {
              '0': 'off',
              '1': 'on',
            },
            'heating.circuits.2.circulation.pump/status': {
              '0': 'off',
              '1': 'on',
            },
            'heating.heatingRod.status/level1': {
              '0': 'false',
              '1': 'true',
            },
            'heating.heatingRod.status/level2': {
              '0': 'false',
              '1': 'true',
            },
            'heating.heatingRod.status/level3': {
              '0': 'false',
              '1': 'true',
            },
            'heating.primaryCircuit.valves.fourWay/state': {
              '0': 'unknown',
              '1': 'heating',
              '2': 'cooling',
            },
          },
          series: [
            {
              feature: 'heating.circuits.4.sensors.temperature.supply/value',
              data: [
                43,
                43,
                43,
                39.6,
                43,
                47,
                50,
                45,
                44,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                47.5,
                48,
                47,
                48,
                49,
                47,
                49,
                48,
                46,
                47,
                43.5,
                43,
                44,
                42,
                43,
                42,
                43,
                41.6,
                43,
                44,
                51,
                53,
                46,
                48.3,
                68.5,
                66,
                48,
                67.5,
                50,
                68,
                51,
                68,
                63,
                52,
                68,
                67,
                52,
                53.3,
                53.3,
                53,
                54,
                54,
                64,
                65,
                54,
                68.5,
                62.5,
                68,
                65,
                68.5,
                65.6,
                54.5,
                68,
                54.5,
                68,
                55.5,
                67,
                63.5,
                56.6,
                57,
                57,
                54,
                54,
                53,
                54,
                52,
                65.6,
                65.3,
                54.5,
                68,
                62,
                68,
                65,
                68,
                65,
                55,
                55,
                54,
                55,
                59,
                56,
                54,
                55,
                54,
                55,
                54,
                55,
                54,
                55,
                55,
                56,
                55.5,
                69,
                66,
                56.6,
                58.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
              ],
            },
            {
              feature: 'heating.circuits.2.sensors.temperature.supply/value',
              data: [
                43,
                43,
                43,
                39.6,
                43,
                47,
                50,
                45,
                44,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                47.5,
                48,
                47,
                48,
                49,
                47,
                49,
                48,
                46,
                47,
                43.5,
                43,
                44,
                42,
                43,
                42,
                43,
                41.6,
                43,
                44,
                51,
                53,
                46,
                48.3,
                68.5,
                66,
                48,
                67.5,
                50,
                68,
                51,
                68,
                63,
                52,
                68,
                67,
                52,
                53.3,
                53.3,
                53,
                54,
                54,
                64,
                65,
                54,
                68.5,
                62.5,
                68,
                65,
                68.5,
                65.6,
                54.5,
                68,
                54.5,
                68,
                55.5,
                67,
                63.5,
                56.6,
                57,
                57,
                54,
                54,
                53,
                54,
                52,
                65.6,
                65.3,
                54.5,
                68,
                62,
                68,
                65,
                68,
                65,
                55,
                55,
                54,
                55,
                59,
                56,
                54,
                55,
                54,
                55,
                54,
                55,
                54,
                55,
                55,
                56,
                55.5,
                69,
                66,
                56.6,
                58.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
              ],
            },
            {
              feature: 'heating.circuits.0.sensors.temperature.supply/value',
              data: [
                43,
                43,
                43,
                39.6,
                43,
                47,
                50,
                45,
                44,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                41.6,
                47.5,
                48,
                47,
                48,
                49,
                47,
                49,
                48,
                46,
                47,
                43.5,
                43,
                44,
                42,
                43,
                42,
                43,
                41.6,
                43,
                44,
                51,
                53,
                46,
                48.3,
                68.5,
                66,
                48,
                67.5,
                50,
                68,
                51,
                68,
                63,
                52,
                68,
                67,
                52,
                53.3,
                53.3,
                53,
                54,
                54,
                64,
                65,
                54,
                68.5,
                62.5,
                68,
                65,
                68.5,
                65.6,
                54.5,
                68,
                54.5,
                68,
                55.5,
                67,
                63.5,
                56.6,
                57,
                57,
                54,
                54,
                53,
                54,
                52,
                65.6,
                65.3,
                54.5,
                68,
                62,
                68,
                65,
                68,
                65,
                55,
                55,
                54,
                55,
                59,
                56,
                54,
                55,
                54,
                55,
                54,
                55,
                54,
                55,
                55,
                56,
                55.5,
                69,
                66,
                56.6,
                58.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
                54.5,
              ],
            },
            {
              feature: 'heating.circuits.1.sensors.temperature.supply/value',
              data: [
                32.5,
                32.5,
                32,
                30,
                30,
                35,
                35.5,
                32,
                33,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                37,
                37,
                37.5,
                37.5,
                38.5,
                37.5,
                38,
                37,
                36,
                36.5,
                34,
                34.5,
                34.5,
                34,
                33.5,
                33,
                34,
                33.5,
                33.5,
                34,
                38.5,
                41,
                36,
                36,
                34.5,
                36,
                37.5,
                38,
                38,
                38,
                37.5,
                37,
                39,
                38.5,
                39.5,
                38,
                39.5,
                40,
                40.5,
                40,
                41.5,
                41.5,
                46.5,
                48.5,
                42.5,
                41,
                38.5,
                41,
                39,
                40,
                37,
                42,
                37,
                39,
                40,
                40,
                41,
                40.5,
                43,
                42.5,
                43.5,
                44,
                43.5,
                41.5,
                42,
                41,
                46,
                47.5,
                43.5,
                41.5,
                39,
                41,
                37,
                40,
                37,
                43,
                43,
                42.5,
                43.5,
                43,
                41,
                42.5,
                43.5,
                42.5,
                43.5,
                42,
                43,
                42.5,
                43,
                42.5,
                43.5,
                43.5,
                46,
                48,
                44.5,
                42.5,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
                42,
              ],
            },
            {
              feature: 'heating.burners.0.modulation/value',
              data: [
                24,
                43,
                35,
                48,
                26,
                51,
                38,
                35,
                47,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                46,
                47,
                28,
                32,
                48,
                36,
                46,
                30,
                34,
                34,
                41,
                34,
                35,
                36,
                33,
                28,
                28,
                28,
                30,
                30,
                30,
                64,
                61,
                37,
                48,
                66,
                58,
                50,
                57,
                54,
                46,
                56,
                55,
                63,
                61,
                80,
                72,
                68,
                53,
                51,
                57,
                57,
                58,
                57,
                83,
                51,
                58,
                63,
                54,
                48,
                54,
                59,
                55,
                38,
                57,
                44,
                66,
                73,
                86,
                60,
                61,
                63,
                24,
                24,
                21,
                23,
                43,
                51,
                87,
                57,
                60,
                50,
                60,
                51,
                59,
                42,
                37,
                18,
                46,
                17,
                37,
                46,
                22,
                22,
                46,
                31,
                44,
                50,
                54,
                55,
                56,
                57,
                57,
                81,
                82,
                56,
                40,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
              ],
            },
            {
              feature: 'heating.boiler.temperature/value',
              data: [
                35.9,
                35.6,
                35.4,
                35.3,
                34.2,
                45.2,
                43.1,
                35.6,
                36.4,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                38.6,
                40.6,
                41,
                40.7,
                41,
                40.9,
                45,
                40.9,
                41.1,
                42.1,
                40,
                40,
                40,
                41.1,
                38.9,
                38.9,
                38.9,
                38.9,
                38.9,
                39.9,
                39.9,
                50.2,
                52.6,
                44.1,
                50,
                65,
                52.7,
                46.8,
                65,
                46.8,
                65,
                48.1,
                65,
                53.6,
                53.6,
                65,
                55.9,
                50.2,
                50.2,
                50.2,
                50.2,
                51.2,
                51.2,
                62.1,
                61.1,
                61.1,
                65,
                57,
                65,
                55.1,
                65,
                55.5,
                55.5,
                65,
                65,
                65,
                52.8,
                65,
                57.2,
                57.2,
                57.2,
                51.9,
                51.9,
                50.9,
                49.2,
                49.2,
                49.2,
                62.8,
                62.8,
                62.8,
                65,
                55.9,
                65,
                56.5,
                65,
                54.2,
                47.1,
                47.7,
                48,
                47.2,
                56,
                48.6,
                47.5,
                48.5,
                47.6,
                48.6,
                48.4,
                49.6,
                50.5,
                51.4,
                51.4,
                52.2,
                52.1,
                64.2,
                63.2,
                53.4,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
                56,
              ],
            },

            {
              feature: 'heating.sensors.temperature.outside/value',
              data: [
                null,
                null,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -24.8,
                -24.8,
                -24.8,
                -24.8,
                -25.5,
                -25.5,
                -25.9,
                -25.9,
                -25.9,
                -26.3,
                -26.3,
                -26.2,
                -26.1,
                -26.1,
                -26.1,
                -26.1,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.1,
                -25.1,
                -25.1,
                -24.6,
                -24.6,
                -24.6,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -24.6,
                -24.6,
                -24.6,
                -24.6,
                -24.4,
                -24.4,
                -24.4,
                -24.4,
                -24.2,
                -23.7,
                -23.7,
                -23.7,
                -23.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.7,
                -24.2,
                -24.2,
                -24.2,
                -24.2,
                -24.2,
                -24.2,
                -24.1,
                -24.1,
                -24.6,
                -24.6,
                -24.6,
                -25.1,
                -25.1,
                -24.9,
                -24.9,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.4,
                -25.4,
                -24.9,
                -24.9,
                -24.9,
                -24.9,
                -24.9,
                -24.9,
                -24.9,
                -25.4,
                -25.4,
                -25.4,
                -25.4,
                -25.4,
                -25.4,
                -25.4,
                -25.4,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.1,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.6,
                -25.1,
                -25.1,
                -25.1,
                -24.6,
                -24.6,
                -24.6,
              ],
            },
            {
              feature: 'heating.dhw.sensors.temperature.hotWaterStorage/value',
              data: [
                null,
                null,
                null,
                27.1,
                27.1,
                27.1,
                26,
                26,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                27.4,
                26.4,
                25.4,
                24.4,
                23.3,
                27.4,
                26.4,
                25.4,
                25.4,
                25.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                24.4,
                23.4,
                23.4,
                23.4,
                36.7,
                47.3,
                46.2,
                47.2,
                46.1,
                47.2,
                46.1,
                47.2,
                48.2,
                48.2,
                44.2,
                48.2,
                48.2,
                48.2,
                47.2,
                46.2,
                46.2,
                46.2,
                45.2,
                45.2,
                44.2,
                43.2,
                47.3,
                45.3,
                47.3,
                44.3,
                47.3,
                45.3,
                47.4,
                46.4,
                47.6,
                46.6,
                44,
                48,
                48,
                48,
                47,
                46,
                46,
                45,
                45,
                45,
                44,
                44,
                44,
                43.1,
                47.3,
                45.2,
                47.6,
                44.6,
                47.8,
                44.8,
                41.7,
                39.7,
                36.7,
                34.7,
                38.9,
                38.9,
                38.9,
                36.9,
                36.9,
                36.9,
                36.9,
                36.9,
                35.9,
                35.9,
                35.9,
                35.9,
                35.9,
                34.8,
                30.8,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
                38.3,
              ],
            },
            {
              feature: 'heating.dhw.temperature.main/value',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                25,
                25,
                25,
                25,
                25,
                25,
                25,
                25,
                25,
                25,
                25,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                24,
                30,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                45,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                38,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
              ],
            },
            {
              feature: 'heating.circuits.1.operating.programs.normal/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
              ],
            },
            {
              feature: 'heating.circuits.0.operating.programs.reduced/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                18,
                18,
                18,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
              ],
            },
            {
              feature: 'heating.sensors.volumetricFlow.allengra/value',
              data: [
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                17,
                18,
                18,
                18,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                19,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
              ],
            },
            {
              feature: 'heating.dhw.sensors.temperature.outlet/value',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
              ],
            },
            {
              feature: 'heating.circuits.0.operating.programs.normal/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                16,
                17,
                17,
                18,
                18,
                18,
                19,
                19,
                19,
                19,
                19,
                19,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                21,
                21,
                21,
                21,
                21,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                19,
                19,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
                18,
              ],
            },
            {
              feature: 'heating.circuits.1.operating.programs.reduced/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                15,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                14,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
                13,
              ],
            },
            {
              feature: 'heating.circuits.2.heating.curve/shiftValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.circuits.2.heating.curve/slopeValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
                1.4,
              ],
            },
            {
              feature: 'heating.circuits.1.heating.curve/slopeValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
                0.5,
              ],
            },
            {
              feature: 'heating.circuits.1.heating.curve/shiftValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.circuits.0.heating.curve/slopeValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
                1.2,
              ],
            },
            {
              feature: 'heating.circuits.0.heating.curve/shiftValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
                2,
              ],
            },
            {
              feature: 'heating.circuits.1.operating.programs.comfort/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
              ],
            },
            {
              feature: 'heating.circuits.0.operating.programs.comfort/temperatureValue',
              data: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
                20,
              ],
            },
            {
              feature: 'heating.heat.production.current/value',
              data: [
                23,
                24,
                29,
                30,
                30,
                30,
                32,
                32,
                27,
                27,
                33,
                32,
                29,
                31,
                34,
                39,
                38,
                43,
                42,
                42,
                42,
                43,
                44,
                48,
                51,
                53,
                58,
                56,
                60,
                57,
                52,
                53,
                57,
                59,
                63,
                70,
                73,
                71,
                72,
                76,
                73,
                72,
                71,
                72,
                74,
                77,
                81,
                84,
                81,
                83,
                82,
                76,
                78,
                79,
                84,
                80,
                82,
                85,
                83,
                80,
                86,
                85,
                89,
                90,
                92,
                92,
                96,
                96,
                96,
                98,
                99,
                94,
                94,
                97,
                94,
                90,
                94,
                99,
                97,
                101,
                104,
                102,
                103,
                103,
                104,
                107,
                106,
                102,
                105,
                109,
                108,
                108,
                108,
                109,
                107,
                104,
                105,
                107,
                109,
                110,
                112,
                111,
                113,
                113,
                117,
                123,
                120,
                119,
                126,
                122,
                127,
                129,
                127,
                131,
                131,
                133,
                132,
                133,
                130,
                132,
                129,
                125,
                127,
                127,
                132,
                131,
                132,
                133,
                130,
                131,
                131,
                134,
                129,
                129,
                130,
                135,
                139,
                137,
                134,
                132,
                133,
                136,
                136,
                135,
                138,
                137,
                138,
                139,
              ],
            },
            {
              feature: 'heating.boiler.sensors.temperature.commonSupply/value',
              data: [
                42,
                46,
                48,
                48,
                47,
                50,
                48,
                51,
                45,
                49,
                49,
                52,
                50,
                56,
                54,
                49,
                47,
                44,
                47,
                47,
                51,
                58,
                61,
                62,
                64,
                64,
                63,
                65,
                69,
                68,
                72,
                68,
                73,
                72,
                71,
                74,
                78,
                77,
                76,
                78,
                80,
                82,
                82,
                81,
                83,
                84,
                82,
                81,
                86,
                88,
                87,
                86,
                82,
                85,
                82,
                84,
                81,
                80,
                80,
                81,
                76,
                80,
                84,
                83,
                84,
                88,
                86,
                84,
                86,
                84,
                80,
                80,
                83,
                81,
                86,
                87,
                88,
                92,
                94,
                94,
                94,
                98,
                96,
                100,
                104,
                106,
                108,
                107,
                113,
                110,
                110,
                105,
                104,
                98,
                97,
                92,
                94,
                95,
                94,
                93,
                94,
                92,
                94,
                97,
                96,
                97,
                97,
                96,
                98,
                97,
                97,
                98,
                99,
                94,
                97,
                98,
                98,
                103,
                102,
                101,
                103,
                104,
                103,
                103,
                105,
                103,
                100,
                99,
                97,
                100,
                103,
                104,
                100,
                101,
                107,
                108,
                108,
                114,
                116,
                113,
                119,
                121,
                124,
                124,
                130,
                136,
                140,
                137,
              ],
            },
            {
              feature: 'heating.sensors.temperature.systemReturn/value',
              data: [
                54,
                56,
                59,
                55,
                58,
                63,
                64,
                64,
                70,
                72,
                67,
                73,
                74,
                75,
                74,
                74,
                79,
                85,
                86,
                90,
                89,
                88,
                90,
                89,
                92,
                97,
                94,
                91,
                95,
                97,
                92,
                89,
                87,
                85,
                81,
                81,
                86,
                86,
                85,
                86,
                84,
                81,
                84,
                86,
                87,
                86,
                90,
                88,
                89,
                91,
                90,
                93,
                94,
                98,
                101,
                100,
                99,
                98,
                97,
                97,
                102,
                100,
                100,
                101,
                101,
                95,
                98,
                97,
                96,
                96,
                93,
                89,
                85,
                79,
                79,
                79,
                80,
                79,
                79,
                80,
                83,
                82,
                85,
                83,
                81,
                87,
                93,
                96,
                97,
                97,
                99,
                99,
                100,
                100,
                98,
                104,
                106,
                111,
                110,
                108,
                112,
                109,
                105,
                103,
                103,
                101,
                96,
                100,
                101,
                99,
                99,
                99,
                98,
                97,
                92,
                91,
                88,
                91,
                91,
                91,
                92,
                89,
                91,
                92,
                92,
                89,
                92,
                89,
                92,
                93,
                92,
                89,
                91,
                94,
                93,
                97,
                100,
                98,
                98,
                105,
                109,
                109,
                112,
                112,
                108,
                110,
                106,
                109,
              ],
            },
            {
              feature: 'heating.sensors.temperature.hydraulicSeparator/value',
              data: [
                33,
                30,
                30,
                35,
                36,
                34,
                34,
                33,
                32,
                32,
                29,
                27,
                27,
                26,
                24,
                24,
                21,
                20,
                25,
                23,
                18,
                16,
                20,
                23,
                19,
                22,
                17,
                14,
                13,
                10,
                10,
                10,
                14,
                13,
                12,
                7,
                10,
                10,
                12,
                14,
                10,
                9,
                11,
                12,
                10,
                8,
                8,
                5,
                8,
                4,
                2,
                -3,
                0,
                5,
                5,
                5,
                5,
                2,
                1,
                1,
                5,
                7,
                10,
                16,
                21,
                22,
                24,
                22,
                18,
                20,
                19,
                18,
                19,
                19,
                17,
                14,
                12,
                17,
                16,
                13,
                14,
                13,
                8,
                8,
                9,
                11,
                11,
                15,
                14,
                8,
                12,
                18,
                17,
                20,
                18,
                18,
                16,
                18,
                15,
                19,
                26,
                28,
                27,
                21,
                22,
                21,
                19,
                22,
                20,
                25,
                30,
                30,
                32,
                33,
                31,
                32,
                30,
                28,
                26,
                26,
                30,
                29,
                24,
                28,
                30,
                34,
                36,
                38,
                42,
                46,
                45,
                42,
                44,
                48,
                50,
                48,
                52,
                51,
                51,
                55,
                52,
                53,
                53,
                55,
                53,
                58,
                58,
                57,
              ],
            },
            {
              feature: 'heating.circuits.3.sensors.temperature.supply/value',
              data: [
                45,
                42,
                43,
                40,
                40,
                43,
                48,
                49,
                54,
                55,
                50,
                48,
                48,
                49,
                51,
                52,
                48,
                52,
                56,
                56,
                54,
                55,
                52,
                56,
                54,
                56,
                58,
                56,
                59,
                63,
                64,
                63,
                65,
                63,
                63,
                65,
                67,
                67,
                63,
                62,
                60,
                62,
                63,
                58,
                58,
                61,
                57,
                62,
                63,
                64,
                66,
                60,
                61,
                61,
                67,
                67,
                64,
                61,
                59,
                57,
                58,
                56,
                58,
                55,
                57,
                60,
                58,
                54,
                54,
                54,
                56,
                58,
                60,
                61,
                63,
                67,
                71,
                69,
                67,
                69,
                67,
                68,
                73,
                70,
                73,
                75,
                74,
                71,
                70,
                71,
                74,
                73,
                67,
                66,
                64,
                60,
                60,
                55,
                56,
                57,
                57,
                52,
                54,
                52,
                55,
                60,
                60,
                56,
                52,
                53,
                54,
                54,
                59,
                60,
                60,
                64,
                61,
                59,
                59,
                61,
                62,
                67,
                67,
                66,
                69,
                68,
                69,
                70,
                73,
                72,
                72,
                73,
                71,
                72,
                76,
                75,
                75,
                74,
                76,
                82,
                83,
                82,
                82,
                86,
                84,
                85,
                85,
                86,
              ],
            },
            {
              feature: 'heating.dhw.pumps.primary/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
              ],
            },
            {
              feature: 'heating.dhw.pumps.circulation/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.boiler.pumps.internal/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
              ],
            },
            {
              feature: 'heating.circuits.0.circulation.pump/status',
              data: [
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.circuits.1.circulation.pump/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.circuits.2.circulation.pump/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
            {
              feature: 'heating.circuits.3.circulation.pump/status',
              data: [
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                0,
                0,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
              ],
            },

            {
              feature: 'heating.heatingRod.status/level1',
              data: [
                null,
                null,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ],
            },
          ],
          enum_series: [
            {
              feature: 'heating.circuits.0.circulation.pump/status',
              device_id: '0',
              value: [0],
              start: [point_start],
            },
            {
              feature: 'heating.circuits.1.circulation.pump/status',
              device_id: '0',
              value: [0],
              start: [point_start],
            },
            {
              feature: 'heating.circuits.2.circulation.pump/status',
              device_id: '0',
              value: [0],
              start: [point_start],
            },
            {
              feature: 'heating.heatingRod.status/level1',
              device_id: '0',
              value: [0, 1, 0, 1, 0],
              start: [
                point_start,
                point_start + timeDiff / 4,
                point_start + timeDiff / 3,
                point_start + timeDiff / 2,
                point_end,
              ],
            },
            {
              feature: 'heating.heatingRod.status/level2',
              device_id: '0',
              value: [0, 1, 0, 1, 0],
              start: [
                point_start,
                point_start + timeDiff / 4,
                point_start + timeDiff / 3,
                point_start + timeDiff / 2,
                ,
                point_end,
              ],
            },
            {
              feature: 'heating.heatingRod.status/level3',
              device_id: '0',
              value: [0, 1, 0, 1, 0],
              start: [
                point_start,
                point_start + timeDiff / 4,
                point_start + timeDiff / 3,
                point_start + timeDiff / 2,
                ,
                point_end,
              ],
            },
            {
              feature: 'heating.primaryCircuit.valves.fourWay/state',
              device_id: '0',
              value: [1],
              start: [point_start],
            },
          ],
        },
      ],
    };
  }
}
export class MockedConnectivityRanking {
  mock(): GenericDataResponse<ConnectivityRanking> {
    return {
      data: {
        customer_id: '050023232323',
        lead_sales_org: '0500',
        sales_org_ranking: '10',
        total_connected_installations: '200',
        mocked_all_ranking_participants: '1580',
        quarterly_overview: [
          {
            quarter: '2023-Q2',
            previous_quarter: '2023-Q1',
            new_installations: 10,
            new_installations_relative_increase: '20',
          },
        ],
      },
    };
  }
}
